import { Injectable } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { Observable } from "rxjs";
import { ApiServerService } from "./api-server";
// import { apiserver } from "./api-server"

export interface UserApiModel {
  roles: Array<string>,
  firstName?: string,
  lastName?: string,
  name?: string,
  displayName: string,
  email: string,
  phoneNumber?: string, 
  photoURL?: string,
  [propName: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class UserApi {
  constructor(
    private aSS: ApiServerService){
  }
  create = (user: UserApiModel): Observable<{ uid: string, authUser: Auth }> => this.aSS.call('api/users/create', user);
  update = (uid: string, data: Partial<UserApiModel>): Observable<Partial<UserApiModel>> => this.aSS.call(`api/users/update/${uid}`, data);
  delete = (uid: string) => this.aSS.call(`api/users/delete/${uid}`);
  disable = (uid: string) => this.aSS.call(`api/users/disable/${uid}`);
  enable = (uid: string) => this.aSS.call(`api/users/enable/${uid}`);
  passwordRecovery = (data: { email: string, actionCodeSettings?: any }) => this.aSS.call(`api/users/passwordRecovery`, data);
  emailVerify = (data: { email: string, actionCodeSettings?: any }) => this.aSS.call(`api/users/emailVerify`, data);
  hasSignedIn = (data: { email: string }) => this.aSS.call(`api/users/hasSignedIn`, data);
}



// export const createUser = (user: UserApi): Observable<{ uid: string, authUser: Auth }> => apiserver('api/users/create', user);

// export const updateUser = (uid: string, data: Partial<UserApi>): Observable<Partial<UserApi>> => apiserver(`api/users/update/${uid}`, data);

// export const deleteUser = (uid: string) => apiserver(`api/users/delete/${uid}`);

// export const disableUser = (uid: string) => apiserver(`api/users/disable/${uid}`);

// export const enableUser = (uid: string) => apiserver(`api/users/enable/${uid}`);

// export const passwordRecovery = (data: { emai: string, actionCodeSettings?: any }) => apiserver(`api//users/passwordRecovery`, data);

// export const emailVerify = (data: { emai: string, actionCodeSettings?: any }) => apiserver(`api//users/emailVerify`, data);

